module.exports = __webpack_public_path__ + "img/brightpoint_icon_active_3.0d1891da.png";